module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__second-3bb4174bf28779f4afb104bacf47bcad.png";